// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
import {
  PatientInsuranceActions,
  PatientInsuranceActionTypes,
} from '../_actions/patient-insurance.actions';
// Models
import { PatientInsuranceModel } from '../_models/patient-insurance.model';
import { QueryParamsModel } from '../../_base/crud';

export interface PatientInsuranceState extends EntityState<PatientInsuranceModel> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedPatientInsuranceId: number;
  lastQuery: QueryParamsModel;
  showInitWaitingMessage: boolean;
  error: any | null;
}

export const adapter: EntityAdapter<PatientInsuranceModel> =
  createEntityAdapter<PatientInsuranceModel>();

export const initialPatientInsuranceState: PatientInsuranceState = adapter.getInitialState({
  PatientInsuranceForEdit: null,
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  lastCreatedPatientInsuranceId: undefined,
  lastQuery: new QueryParamsModel({}),
  showInitWaitingMessage: true,
  error: null,
});

export function patientInsuranceReducer(
  state = initialPatientInsuranceState,
  action: PatientInsuranceActions,
): PatientInsuranceState {
  switch (action.type) {
    case PatientInsuranceActionTypes.PatientInsurancePageToggleLoading: {
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedPatientInsuranceId: undefined,
      };
    }
    case PatientInsuranceActionTypes.PatientInsuranceActionToggleLoading: {
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    }
    case PatientInsuranceActionTypes.PatientInsurancePageRequested: {
      return { ...state, listLoading: true };
    }
    case PatientInsuranceActionTypes.PatientInsurancePageLoaded: {
      const patientInsurance = action.payload.patientInsurance ?? [];
      return adapter.addMany(patientInsurance, {
        ...initialPatientInsuranceState,
        totalCount: action.payload.totalCount,
        listLoading: false,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
      });
    }
    case PatientInsuranceActionTypes.PatientInsuranceOnServerCreated:
      return {
        ...state,
      };
    case PatientInsuranceActionTypes.PatientInsuranceCreated:
      return adapter.addOne(action.payload.patientInsurance, {
        ...state,
        lastCreatedPatientInsuranceId: action.payload.patientInsurance.id,
      });
    case PatientInsuranceActionTypes.PatientInsuranceUpdated:
      return adapter.updateOne(action.payload.partialPatientInsurance, state);
    case PatientInsuranceActionTypes.PatientInsuranceDeleted:
      return adapter.removeOne(action.payload.patientInsuranceId, state);
    case PatientInsuranceActionTypes.ThrowPatientInsuranceError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case PatientInsuranceActionTypes.ClearPatientInsuranceErrors: {
      return {
        ...state,
        error: null,
      };
    }
    case PatientInsuranceActionTypes.PatientInsurancePageCancelled: {
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    }
    case PatientInsuranceActionTypes.ClearPatientInsuranceState: {
      return initialPatientInsuranceState;
    }
    default:
      return state;
  }
}

export const getPatientInsurancSetate =
  createFeatureSelector<PatientInsuranceModel>('patientInsurance');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
